import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchUser } from "../redux/actions/user";
import PropTypes from "prop-types";

import Authenticating from './Authenticating';

export default function (ComposedComponent) {
    class Authentication extends Component {
        state = {
            isLoading: true,
            error: null
        };

        async componentDidMount() {
            try {
                await this.props.fetchUser();
            } catch (error) {
                this.setState({ error: error.message });
            } finally {
                this.setState({ isLoading: false });
            }
        }

        render() {
            const { user, profile, authenticating } = this.props;
            const { isLoading, error } = this.state;

            if (authenticating || isLoading) {
                return <Authenticating />;
            }

            if (!user) {
                this.props.history.push("/");
                return null;
            }

            if (error) {
                return (
                    <div className="alert alert-danger">
                        Erreur: {error}
                    </div>
                );
            }

            return <ComposedComponent {...this.props} />;
        }
    }

    Authentication.propTypes = {
        user: PropTypes.object,
        profile: PropTypes.object,
        authenticating: PropTypes.bool,
        fetchUser: PropTypes.func.isRequired,
        history: PropTypes.object.isRequired
    };

    const mapStateToProps = state => ({
        user: state.user.user,
        profile: state.user.profile,
        authenticating: state.status.authenticating
    });

    const mapDispatchToProps = {
        fetchUser
    };

    return connect(mapStateToProps, mapDispatchToProps)(Authentication);
}